import { pluralize } from 'common/utils/utils';

const FormItemTitle = ({
  title,
  subtitle,
  data = []
}: {
  title: string;
  subtitle?: string | JSX.Element;
  data?: any[];
}) => {
  return (
    <div className='pb-2'>
      <label className='text-sm'>
        {title}
        {data.length > 0 && ` (${pluralize(data.length, 'team')} selected)`}
      </label>
      {subtitle && <p className='text-sm text-gray-500'>{subtitle}</p>}
    </div>
  );
};

export default FormItemTitle;
